import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAppStatusSlice } from './get';

export const coreDataSecurityAppStatusReducers = combineReducers({
	get: getCoreDataSecurityAppStatusSlice.asyncReducers
});

export const coreDataSecurityAppStatusWatchers = combineAllWatchers([ getCoreDataSecurityAppStatusSlice.asyncWatchers ]);
